import { render } from "./DataTableStudents.vue?vue&type=template&id=592f89fe&ts=true"
import script from "./DataTableStudents.vue?vue&type=script&lang=ts"
export * from "./DataTableStudents.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/com.latudio.www.teachers_staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__